import { ImagesData, ImagesMap, SrcSetItem } from "./types";

export function buildSrcSet(set: SrcSetItem[]): string {
	return set.map((img) => `${img.src} ${img.width}w`).join(", ");
}

export function renderSources(set: SrcSetItem[]) {
    return set.map(({ media, src, type }) => (
        <source
            key={src + media + type}
            srcSet={src}
            media={media}
            type={type}
        />
    ));
}

export const getImageData = (id: string, imagesData: ImagesMap): ImagesData | undefined => {
  	return imagesData[id];
};